import React, { useEffect, useCallback, useState } from 'react';
import { Box, Paper, Typography, IconButton, Grid } from '@mui/material';
import TableComponent from '../../../common/table/Table';
import AxiosInstance from '../../../../server/AxioInstance';
import {
  CheckCircleOutlineIcon,
  HighlightOffIcon,
  DownloadingIcon,
  PublishIcon,
  SmsIcon,
} from '../../../../shared/components/icon';
import { useDownload, useDialog, useSnackbar } from '../../../../shared/context';
import AlertReprovedDialogSlide from '../../../Dialog/ApprovedDocumentDialog';

const bodyBox = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, .5)',
};

const columns = [
  { id: 'more_info', label: 'Mais', align: 'center' },
  { id: 'title', label: 'Titulo', align: 'center' },
  { id: 'typeRequest', label: 'Tipo de aprovação', align: 'center' },
  { id: 'GEDY_document_approval', label: 'Status', align: 'center' },
  { id: 'registration_date_approval', label: 'Data Solicitação', align: 'center' },
  { id: 'download', label: 'Download', align: 'center' },
  { id: 'acao', label: 'Ação', align: 'center' },
];

const BodyModifyDocument = () => {
  const { isDialogOpen, openDialog, closeDialog, dialogData } = useDialog('reprovedDocumentDialog');
  const { handleDownload } = useDownload();
  const { showSnackbar } = useSnackbar();
  const [rows, setRows] = useState([]);

  // ------------ function dialog ------------ //
  const handleOpenDialog = (item, index) => {
    openDialog({ item, index });
  };

  const handleCloseDialog = () => {
    closeDialog();
  };

  const handleConfirmAction = async (comments, approveDocument) => {
    try {
      const temp = { ...approveDocument.item, comments: comments };
      await AxiosInstance.post('/manipulate-documents/approve-document', temp);
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Atualização feita com sucesso',
        variant: 'success',
      });
      await GetData();
      handleCloseDialog();
    } catch (error) {
      showSnackbar({
        vertical: 'top',
        horizontal: 'right',
        message: 'Erro ao enviar a requisição: ' + error.message,
        variant: 'error',
      });
    }
  };

  const handleCancelAction = () => {
    handleCloseDialog();
  };
  // ------------ function dialog ------------ //

  const handleApproved = async (item, approve) => {
    const approver = localStorage.getItem('@gedy:user');
    const approveDocument = {
      ...item,
      approver: approver,
      approve: approve,
      comments: '',
    };
    handleOpenDialog(approveDocument);
  };

  const handlePublishDocument = async (item) => {
    await AxiosInstance.post('/manipulate-documents/publishDocumnet', item);
    await GetData();
  };

  const buttonMoreInfo = (item) => {
    return (
      <IconButton aria-label="publish" onClick={() => console.log(item)}>
        <SmsIcon fontSize="inherit" />
      </IconButton>
    );
  };

  const buttonDownload = (item, index) => {
    return (
      <IconButton
        aria-label="reprova"
        // onClick={() => handleGetFile(item)}
        onClick={() => handleDownload(item, index)}
      >
        <DownloadingIcon fontSize="large" color="primary" />
      </IconButton>
    );
  };

  const buttonApprover = (item) => {
    return item.document_status === 2 ? (
      <>
        <IconButton
          aria-label="publish"
          onClick={() => handlePublishDocument(item)}
          disabled={Boolean(item.login_approved)}
        >
          <PublishIcon fontSize="inherit" color={item.login_approved ? 'primary' : 'disabled'} />
        </IconButton>
      </>
    ) : (
      <>
        <IconButton
          aria-label="reprova"
          onClick={() => handleApproved(item, 'approved')}
          disabled={Boolean(item.login_approved)}
        >
            <CheckCircleOutlineIcon fontSize="inherit" color="success" />
          </IconButton>
          <IconButton
            aria-label="reprova"
            onClick={() => handleApproved(item, 'disapproved')}
            disabled={Boolean(item.login_approved)}
          >
            <HighlightOffIcon fontSize="inherit" color="error" />
          </IconButton>
        </>
    );
  };

  const GetData = useCallback(async (status) => {
    const result = await AxiosInstance.post(
      '/manipulate-documents/validation?user=' + localStorage.getItem('@gedy:user'),
      status,
    );
    const temp = result?.data?.rows?.map((item, index) => ({
      ...item,
      more_info: buttonMoreInfo(item),
      download: buttonDownload(item, index),
      acao: buttonApprover(item),
    }));
    setRows(temp);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    GetData();
  }, [GetData]);

  return (
    <>
      {isDialogOpen() && (
        <AlertReprovedDialogSlide
          handleClose={handleCloseDialog}
          handleConfirm={handleConfirmAction}
          handleCancel={handleCancelAction}
          dialogData={dialogData}
        />
      )}
      <form method="POST">
        <Box p={2} component={Paper} sx={bodyBox}>
          <Box>
            <Typography variant="h4" mb={1}>
              Aprovação de Documentos
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} xl={12}>
                <TableComponent columns={columns} rows={rows} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </form>
    </>
  );
};

export default BodyModifyDocument;
